export var ActionsMenuLayoutDataHooks;
(function (ActionsMenuLayoutDataHooks) {
    ActionsMenuLayoutDataHooks["mobile"] = "data-mobile";
})(ActionsMenuLayoutDataHooks || (ActionsMenuLayoutDataHooks = {}));
export var ActionsMenuLayoutItemAlignment;
(function (ActionsMenuLayoutItemAlignment) {
    ActionsMenuLayoutItemAlignment["left"] = "left";
    ActionsMenuLayoutItemAlignment["center"] = "center";
    ActionsMenuLayoutItemAlignment["right"] = "right";
})(ActionsMenuLayoutItemAlignment || (ActionsMenuLayoutItemAlignment = {}));
//# sourceMappingURL=types.js.map